var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "packageWrap"
  }, [_c('div', {
    staticClass: "packageLeft"
  }, [_vm.businessType == 'COMPREHENSIVE_CUSTOMIZED' ? _c('p', {
    staticClass: "fs14 fwb mb6"
  }, [_vm._v("Comprehensive Corporate Services (customized)")]) : _vm._e(), _vm.businessType == 'FUND_ADMIN_CUSTOMIZED' ? _c('p', {
    staticClass: "fs14 fwb mb6"
  }, [_vm._v("Fund Admin Services (customized)")]) : _vm._e(), _c('p', [_c('span', {
    staticClass: "fs20 fwb orange vam"
  }, [_vm._v(_vm._s(_vm.currencyAndAmountFormat(_vm.billingCurrency, _vm.quotationPart.subTotalPrice)))]), _c('span', {
    staticClass: "ml6 fs14 fwb blackD8 vam"
  }, [_vm._v("(" + _vm._s(_vm.quotationPart.subTotalDesp) + ")")])])]), _c('div', {
    staticClass: "packageRight"
  }, [_c('div', {
    staticClass: "flex flex-direction-row details"
  }, [_c('div', {
    staticClass: "mr20"
  }, [_c('p', {
    staticClass: "fs12 fwb"
  }, [_vm._v("Package Includes:")]), _c('ul', {
    staticClass: "fs12 black45 lh22"
  }, _vm._l(_vm.quotationPart.itemList, function (son) {
    return _c('li', {
      key: "son-".concat(son.id)
    }, [_c('span', {
      staticClass: "fwb green fs12 el-icon-check"
    }), _vm._v(" " + _vm._s(son.title) + " "), _c('span', [_vm._v("(" + _vm._s(_vm.currencyAndAmountFormat(_vm.billingCurrency, _vm.serviceChargeCalculation(son.amount, son.thirdPartyFee, son.otherFee))) + ")")]), son.startDate && son.endDate ? _c('el-popover', {
      attrs: {
        "placement": "bottom",
        "trigger": "hover"
      }
    }, [_c('span', {
      staticClass: "fs12"
    }, [_vm._v(_vm._s(son.startDate) + " ~ " + _vm._s(son.endDate))]), _c('span', {
      staticClass: "ml2 fs13 blackD8 el-icon-question",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    })]) : _vm._e()], 1);
  }), 0)]), _c('div', {
    staticClass: "mr20"
  }, [_vm._m(0), _c('ul', {
    staticClass: "fs12 black45 lh22"
  }, _vm._l(_vm.mergeSameAttrList(_vm.quotationPart.itemList, 'noteForThirdParty', 'thirdPartyFee'), function (part) {
    return _c('li', {
      key: "part-".concat(part.id)
    }, [part.noteForThirdParty ? _c('span', [_vm._v("- " + _vm._s(part.noteForThirdParty))]) : _vm._e(), _vm.$isNumberLike(part.thirdPartyFee) ? _c('span', [_vm._v("(" + _vm._s(_vm.currencyAndAmountFormat(_vm.billingCurrency, part.thirdPartyFee)) + ")")]) : _vm._e()]);
  }), 0)]), _c('div', [_vm._m(1), _c('ul', {
    staticClass: "fs12 black45 lh22"
  }, _vm._l(_vm.mergeSameAttrList(_vm.quotationPart.itemList, 'noteForOther', 'otherFee'), function (other) {
    return _c('li', {
      key: "other-".concat(other.id)
    }, [other.noteForOther ? _c('span', [_vm._v("- " + _vm._s(other.noteForOther))]) : _vm._e(), _vm.$isNumberLike(other.otherFee) ? _c('span', [_vm._v("(" + _vm._s(_vm.currencyAndAmountFormat(_vm.billingCurrency, other.otherFee)) + ")")]) : _vm._e()]);
  }), 0)])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "fs12 pt18 lh22"
  }, [_c('span', {
    staticClass: "fwb green fs12 el-icon-check"
  }), _vm._v(" Third Party Fee: ")]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "fs12 pt18 lh22"
  }, [_c('span', {
    staticClass: "fwb green fs12 el-icon-check"
  }), _vm._v(" Other Fee: ")]);
}]

export { render, staticRenderFns }